// Testlab for testing API or plugins, to be removed when site goes live

jQuery(function ($) {
  if ($('.idea-indices-chart').length === 0) { return; }

  let resizeTimeout;
  let chartInterval;
  let startYear;
  let endYear;
  let totalSegments;
  let indicesData;

  const gsodCid = $('#gsod-country-id').data('id');

  // GET /////////////////////////////////////////////
  const settings = {
    url: "/api/gsodindices?cid=" + gsodCid,
    method: "GET",
    timeout: 0,
    headers: {
      "Content-Type": "application/json",
    },
    error: function (error) {
      console.log("error", error);
    },
  };
  $.ajax(settings).done(function (response) {
    // console.log('response', JSON.parse(response));
    indicesData = JSON.parse(response);

    startYear = indicesData[0].past_data[0].label;
    endYear = indicesData[0].past_data[indicesData[0].past_data.length - 1].label;

    drawCharts();
  });

  function drawCharts(showTooltip = false, coordinatesIndex = -1) {
    $('.idea-indices-chart').each(function(index) {
      const thisElm = $(this);
      const chartType = thisElm.data('chart-type');
      const strokeColor = thisElm.data('stroke-color');
      const endValue = indicesData[index].past_data[indicesData[index].past_data.length - 1].value;

      thisElm.find('.indices-start-year').html(startYear);
      thisElm.find('.indices-end-year').html(endYear);
      thisElm.find('.latest-indice').html(endValue);

      let canvas = $(this).find('canvas')[0];
      let ctx = canvas.getContext("2d");
      let coordinates = [];

      canvas.width = canvas.getBoundingClientRect().width * 2;
      canvas.height = canvas.getBoundingClientRect().height * 2;

      const chartData = indicesData[index].past_data.map((d, i) => { return d.value; });

      function drawLineChart(showTooltip = false, coordinatesIndex = -1) {
        const cvWidth = canvas.width;
        const cvHeight = canvas.height;
        const sidePadding = 10;
        const chartTopLeft = 0 + sidePadding;
        const chartBottom = cvHeight - sidePadding;
        const chartWidth = cvWidth - (sidePadding * 2);
        const chartHeight = cvHeight - (sidePadding * 2);
        const minIndice = 0;
        const maxIndice = 1;
        const xInterval = chartWidth / (chartData.length - 1)

        ctx.clearRect(0, 0, cvWidth, cvHeight);

        ctx.strokeStyle = "#FFFFFF33";
        ctx.lineWidth = 3;

        // Draw the max value line
        ctx.beginPath();
          ctx.moveTo(chartTopLeft, chartTopLeft);
          ctx.lineTo(chartTopLeft + chartWidth, chartTopLeft);
          ctx.stroke();
        ctx.closePath();

        // Draw the min value line
        ctx.beginPath();
          ctx.moveTo(chartTopLeft, chartBottom);
          ctx.lineTo(chartTopLeft + chartWidth, chartBottom);
          ctx.stroke();
        ctx.closePath();

        ctx.setLineDash([15, 5]);

        // Draw 70% line (dash)
        ctx.beginPath();
          ctx.moveTo(chartTopLeft, chartTopLeft + (chartHeight * 0.3));
          ctx.lineTo(chartTopLeft + chartWidth, chartTopLeft + (chartHeight * 0.3));
          ctx.stroke();
        ctx.closePath();

        // Draw 40% line (dash)
        ctx.beginPath();
          ctx.moveTo(chartTopLeft, chartTopLeft + (chartHeight * 0.6));
          ctx.lineTo(chartTopLeft + chartWidth, chartTopLeft + (chartHeight * 0.6));
          ctx.stroke();
        ctx.closePath();

        ctx.lineWidth = 5;
        ctx.strokeStyle = strokeColor || "#36A0E7";
        ctx.setLineDash([]);

        let x;
        let y;

        // Drawing the line
        x = 0 + sidePadding;
        y = Math.floor(parseFloat((maxIndice - chartData[0]) * chartHeight));

        let peak = 0;
        let peakCoordinate = { x: chartTopLeft + chartWidth, y: 0 };

        ctx.beginPath();
          ctx.moveTo(x, y);
          coordinates[0] = { x, y };

          for (i=1; i<chartData.length; i++) {
            x+= xInterval;
            y = Math.floor(parseFloat((maxIndice - chartData[i]) * chartHeight));
            ctx.lineTo(x, y);

            if (chartData[i] > peak) {
              peak = chartData[i];
              peakCoordinate.y = y;
            }

            coordinates[i] = { x, y };
          }

          ctx.stroke();
        ctx.closePath();

        if(chartType !== "basic"){
          // Drawing gradient tone under past data line chart //////////////////////////////////////////////
          let grd = ctx.createLinearGradient(cvWidth / 2, chartTopLeft, cvWidth / 2, chartBottom);
          grd.addColorStop(0, "#36A0E755");
          grd.addColorStop(1, "#36A0E700");

          x = 0 + sidePadding;
          y = Math.floor(parseFloat((maxIndice - chartData[0]) * chartHeight));

          ctx.beginPath();
            ctx.moveTo(x, chartBottom);
            ctx.lineTo(x, y);

            for (i=1; i<chartData.length; i++) {
              x+= xInterval;
              y = Math.floor(parseFloat((maxIndice - chartData[i]) * chartHeight));
              ctx.lineTo(x, y);
            }

            ctx.lineTo(x, chartBottom);
          ctx.closePath();

          ctx.fillStyle = grd;
          ctx.fill();

          // Draw peak point of line
          ctx.beginPath();
            ctx.arc(peakCoordinate.x, peakCoordinate.y, 10, 0, 2 * Math.PI);
            ctx.fillStyle = strokeColor || "#36A0E7";
            ctx.fill();
          ctx.closePath();
        }

        // Draw a dot on the line for tooltip position
        if (showTooltip) {
          ctx.beginPath();
            ctx.arc(coordinates[coordinatesIndex].x, coordinates[coordinatesIndex].y, 10, 0, 2 * Math.PI);
            ctx.fillStyle = strokeColor || "#36A0E7";
            ctx.fill();
          ctx.closePath();
        }
      }

      drawLineChart();

      canvas.addEventListener('mousemove', function(e) {
        const rect = canvas.getBoundingClientRect();

        // * 2 because canvas is at 2x scale
        const mx = Math.floor((e.clientX - rect.left)) * 2;
        const my = Math.floor((e.clientY - rect.top)) * 2;

        let showTooltip = false;
        let coordinatesIndex;

        $.each(coordinates, function(index) {
          // x y of indices
          const x = $(this)[0].x;
          const y = $(this)[0].y;
          const distance = Math.sqrt(
            ((mx - x) * (mx - x))
            +
            ((my - y) * (my - y))
          );

          if (distance <= 15) {
            showTooltip = true;
            coordinatesIndex = index;
            renderTooltip(thisElm, startYear + coordinatesIndex, chartData[coordinatesIndex], (x / 2), (y / 2));
          }
        })

        if (showTooltip) {
          drawLineChart(true, coordinatesIndex);
        } else {
          drawLineChart();
          thisElm.parent().find('.line-chart-tooltip').remove();
        }

        // drawDot(cvW / 2, cvH / 2, mx, my);
      });

      canvas.addEventListener('mouseleave', function(e) {
        drawLineChart();
        thisElm.parent().find('.line-chart-tooltip').remove();
      });
    });
  }

  $(window).on('resize', function(){
    wWidth = $(window).width();

    clearTimeout(resizeTimeout);

    resizeTimeout = setTimeout(() => {
      drawCharts();
    }, 100);
  });

  function renderTooltip(elm, year, value, x, y) {
    if (elm.find('.line-chart-tooltip').length > 0) {
      elm.find('.line-chart-tooltip span.tooltip-year').text(year);
      elm.find('.line-chart-tooltip span.tooltip-value').text(addZeroAtTheEnd(value));
    } else {
      const html = '<div class="line-chart-tooltip ' +
                      'absolute -translate-x-1/2 -translate-y-full pb-3 ' +
                      'text-ideaTextBlack100 ' +
                      'pointer-events-none">' +
                      '<div class="bg-white drop-shadow-tooltip font-aileron font-bold text-gsodBody text-xs whitespace-nowrap px-4 py-2">' +
                        '<span class="tooltip-year">' + year + '</span> - <span class="tooltip-value">' + value + '</span>' +
                      '</div>' +
                    '</div>';

      elm.find('canvas').parent().append(html);
    }

    elm.find('.line-chart-tooltip').css('top', y +'px');
    elm.find('.line-chart-tooltip').css('left', x +'px');
  }

  function addZeroAtTheEnd(text) {
    // Make sure number is in 2 decimals
    if (text == "0") {
      return "0.00";
    } else if ((text + "").length < 4) {
      return text+= "0";
    } else {
      return text;
    }
  }
});
